import { render } from "./Filetype.vue?vue&type=template&id=0d647ec4&scoped=true"
import script from "./Filetype.vue?vue&type=script&lang=js"
export * from "./Filetype.vue?vue&type=script&lang=js"

import "./Filetype.vue?vue&type=style&index=0&id=0d647ec4&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d647ec4"]])

export default __exports__